'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _cell = require('../cell');

var _cell2 = _interopRequireDefault(_cell);

var _style = require('./style.css');

var _style2 = _interopRequireDefault(_style);

var _types = require('../types');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var cx = _bind2.default.bind(_style2.default);

var Rows = function Rows(_ref) {
  var rows = _ref.rows,
      columns = _ref.columns,
      _ref$compact = _ref.compact,
      compact = _ref$compact === undefined ? false : _ref$compact,
      renderRow = _ref.renderRow;
  return _react2.default.createElement('tbody', null, rows.map(function (row, rowIdx) {
    var rowClasses = cx({
      'xsui-table-rows__row': true,
      'xsui-table-rows__row--colored': !(rowIdx % 2)
    });

    if (renderRow) {
      return renderRow({
        row: row,
        columns: columns,
        compact: compact,
        rowIndex: rowIdx,
        className: rowClasses,
        CellComponent: _cell2.default
      });
    }

    return _react2.default.createElement('tr', {
      key: 'row-' + (row.id || rowIdx),
      className: rowClasses
    }, columns.map(function (column, columnIdx) {
      return _react2.default.createElement(_cell2.default, {
        key: 'row-' + (row.id || rowIdx) + '-' + column.id,
        row: row,
        column: column,
        rowIndex: rowIdx,
        columnIndex: columnIdx,
        compact: compact
      });
    }));
  }));
};

Rows.propTypes = {
  columns: _propTypes2.default.arrayOf(function () {
    return (typeof _types.bpfrpt_proptype_Column === 'function' ? _types.bpfrpt_proptype_Column.isRequired ? _types.bpfrpt_proptype_Column.isRequired : _types.bpfrpt_proptype_Column : _propTypes2.default.shape(_types.bpfrpt_proptype_Column).isRequired).apply(this, arguments);
  }).isRequired,
  rows: _propTypes2.default.arrayOf(_propTypes2.default.object.isRequired).isRequired,
  compact: _propTypes2.default.bool.isRequired,
  renderRow: function renderRow() {
    return (typeof _types.bpfrpt_proptype_RenderRow === 'function' ? _types.bpfrpt_proptype_RenderRow : _propTypes2.default.shape(_types.bpfrpt_proptype_RenderRow)).apply(this, arguments);
  }
};
exports.default = Rows;